import React, { FC, useCallback } from 'react'
import { Button } from '@wmgtech/legato'
import { useNavigate } from 'react-router-dom'
import { FormAdminContainerProps } from './FormAdminContainer.props'

import './FormAdminContainer.scss'

const FormAdminContainer: FC<FormAdminContainerProps> = ({ children, backLink, actions }) => {
  const navigate = useNavigate()

  const onBackClick = useCallback(() => {
    backLink ? navigate(backLink) : navigate(-1)
  }, [navigate, backLink])

  return (
    <div className="form-container">
      <div className="form-container__action">
        <Button
          secondaryIcon="fa-light fa-arrow-left"
          containerStyle="outline"
          colorType="info"
          className="back-button"
          onClick={onBackClick}
        >Back</Button>
        <div className="form-container__action--content">{actions}</div>
      </div>
      <div className="form-container__content">{children}</div>
    </div>
  )
}

export default FormAdminContainer
